<template>
<div class='mask' @click.self='close'>
  <div class='body'>
    <h4>First name</h4>
      <input type='text' v-model='firstName' class='dark'/>
    <h4>Email</h4>
      <input type='text' v-model='email' class='dark'/>
    <h4>Phone</h4>
      <input type='text' v-model='phone' class='dark'/>
    <div>
      <input type='button' @click='submit()' value='create' class='dark' />
    </div>

  </div>

</div>
</template>

<script>
export default {
  props: ["eventid"],
  data() {
    return {
      firstName: "",
      phone: "",
      email: ""
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$store
        .dispatch("attendees/create", {
          firstName: this.firstName,
          phone: this.phone,
          email: this.email,
          eventId: this.eventid
        })
        .then(() => {
          this.close();
        });
    }
  },
  computed: {}
};
</script>

<style scoped lang='scss'>
.mask {
  width: 100vw;
  height: 100vh;
  background: hsla(0, 0%, 0%, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.body {
  width: 60vw;
  min-width: 800px;
  background: $gray-1;
  padding: 12px 32px;
  max-height: 80vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/event/attendeeCreate.vue